import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable, throwError } from 'rxjs';

export interface FileAccessResponse {
  url: string;
  contentType: string;
  fileName: string;
  expiresAt: string;
}

interface InitiateMaterialUploadResponse {
  id: number;
  uploadUrl: string;
  contentType: string;
  fileName: string;
  expiresAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class FileService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  uploadfile(formdata: FormData): Observable<HttpEvent<any>> {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any>(this.apiUrl + "files/fileupload", formdata, {
      headers,
      reportProgress: true,
      observe: 'events'
    });
  }

  uploadMaterialFile(formdata: FormData, materialType?: number): Observable<HttpEvent<any>> {
    const file = formdata.get('file');
    if (!(file instanceof File)) {
      return throwError(() => new Error('No file provided for upload'));
    }

    return this.uploadMaterialFileDirect(file, materialType);
  }

  uploadMaterialFileDirect(file: File, materialType?: number): Observable<HttpEvent<any>> {
    const token = this._authservice.getAuthToken();
    const authHeaders = new HttpHeaders({ 'Authorization': 'Bearer ' + token });

    const initiateBody = {
      fileName: file.name,
      contentType: file.type || 'application/octet-stream',
      fileSize: file.size,
      materialType: materialType ?? null
    };

    return new Observable<HttpEvent<any>>(observer => {
      this.http.post<InitiateMaterialUploadResponse>(
        this.apiUrl + 'materials/initiateUpload',
        initiateBody,
        { headers: authHeaders }
      ).subscribe({
        next: (init) => {
          this.http.put(init.uploadUrl, file, {
            headers: new HttpHeaders({ 'Content-Type': init.contentType }),
            reportProgress: true,
            observe: 'events'
          }).subscribe({
            next: (putEvent) => {
              if (putEvent.type === HttpEventType.UploadProgress) {
                observer.next(putEvent);
                return;
              }

              if (putEvent.type === HttpEventType.Response) {
                this.http.post<any>(
                  this.apiUrl + 'materials/completeUpload',
                  { fileId: init.id },
                  { headers: authHeaders }
                ).subscribe({
                  next: (fileMetaData) => {
                    observer.next(new HttpResponse({ body: fileMetaData }));
                    observer.complete();
                  },
                  error: (err) => observer.error(err)
                });
              }
            },
            error: (err) => observer.error(err)
          });
        },
        error: (err) => observer.error(err)
      });
    });
  }

  downloadFile(fileid: number): Observable<FileAccessResponse> {
		let params = new HttpParams();
		params = params.append("id",fileid);
		const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
		return this.http.get<FileAccessResponse>(this.apiUrl + 'files/downloadFile', { headers, params });
	}

  downloadMaterialFile(fileid: number): Observable<FileAccessResponse> {
    let params = new HttpParams();
    params = params.append('id', fileid);
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get<FileAccessResponse>(this.apiUrl + 'materials/downloadFile', { headers, params });
  }

}
